import { MetricsTotalType } from "components/product-collection/product-collection-views/product-collection-grid-view/product-collection-grid-view-helper";
import { referenceMetricValueOrCompute } from "../sibling-value-getter/getter";
import { MetricsKind } from "../types";
import { UNITS } from "./formula-units";
import { getDeliveriesFromAllocationDimension } from "helpers/allocation-dimension";

export const AVERAGE_UNITS = ({ factoryOptions, getterParams }) => {
    const { doors, totalType } = factoryOptions;
    const unitsTotal = referenceMetricValueOrCompute(
        () => UNITS({ factoryOptions, getterParams }),
        getterParams,
        MetricsKind.UNITS
    );

    if (unitsTotal && doors.length > 0) {
        if (totalType === MetricsTotalType.GrandTotalMetric) {
            const { context } = getterParams;
            const { tileGridContext } = context;
            const { allocationDimensions } = tileGridContext;
            const deliveriesFromDimension = allocationDimensions[0].dimension_values;

            const deliveries = getDeliveriesFromAllocationDimension(deliveriesFromDimension);

            return unitsTotal / (deliveries.length * doors.length);
        }

        return unitsTotal / doors.length;
    }
    return undefined;
};
